/**
 *  app-relayter-web
 *  Copyright © 2019 Creative Media Network. All rights reserved.
 */
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiConstants } from '../api/api.constant';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()
export class CredentialsInterceptor implements HttpInterceptor {
    private addWithCredentials(request: HttpRequest<any>): HttpRequest<any> {
        return request.clone({
            // patch the request with https://angular.io/api/common/http/HttpRequest#withCredentials
            withCredentials: true
        });
    }

    /**
     * Configure the request to exchange cookies with this endpoint in certain cases
     * This prevent the app in sending the cookies in every request to our Relayter API
     * Should be sent with outgoing credentials (cookies) (See: https://angular.io/api/common/http/HttpRequest).
     * @param {HttpRequest<any>} request
     * @param {HttpHandler} next
     * @returns {Observable<HttpEvent<any>>}
     */
    public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (this.shouldSendCredentials(request)) {
            request = this.addWithCredentials(request);
        }
        return next.handle(request);
    }

    private shouldSendCredentials(request: HttpRequest<any>): boolean {
        const url = request.url ?? '';
        const normalizedApiServer = environment.API_SERVER?.replace(/\/$/, '');

        if (normalizedApiServer && (url.startsWith('http://') || url.startsWith('https://'))) {
            return url.startsWith(normalizedApiServer);
        }

        const apiPathPrefix = `/${ApiConstants.API_BASE_PATH}/`;
        return url.startsWith(apiPathPrefix) || url === `/${ApiConstants.API_BASE_PATH}`;
    }
}
